export default __webpack_public_path__ + "static/afterglowReflection-b91d0804f270d8f813be954a97b40dac.svg";